module.exports = __webpack_public_path__ + "static/media/check.945d9456.svg";